module.exports = __webpack_public_path__ + "static/media/girls_who_code_white.ca36fffc.svg";